module.exports = __webpack_public_path__ + "img/right-light.99bc74dd.png";